export const analytics = {
  projectProgress: "Progreso del proyecto",
  hi: "Hola",
  realProgress: "Progreso real",
  welcomeBack: "Bienvenido",
  moduleStatistics: "Estadísticas de módulos",
  onTime: "A tiempo",
  overdue: "Atrasado",
  constructionPercentage: "Porcentaje de construcción",
  completed: "Completado",
  thisWeek: "Esta semana",
  workForce: "Fuerza laboral",
  hours: "Horas",
  completedTasks: "Tareas completadas",
  analytics: "Analíticas",
  addWidgets: "Agrega tus widgets para mostrar",
  projectStatistics: "Estadísticas de proyecto",
  rfis: "RFIs",
tasks: "Tareas",
submittals: "Submittals",
delayed: "Atrasado",
closed: "Cerrado",
pending: "Pendiente",
onProgress: "En Progreso",
done: "Hecho",
selectWidget: "Seleccione el widget de su elección",
widgetDisplayed: "El widget seleccionado se mostrará en su tablero"

};
